import { LoginAluno } from "../../../StudentPanel/LoginAluno/index.jsx";
import React from "react";
export default function LoginAdmin(props) {
  return <LoginAluno {...props} />;
}
